import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as Api from '../../api/subscriptionApi';
import { MOBILE_VIDEO_STATUS } from '../../config/consts';
import { selectors as companySelectors } from '../company';
import { errorHelper, responseValidateStatusOrThrow } from '../helpers';
import { addSnackbarSuccess } from '../notifications/actions';
import { selectors as sitesSelectors } from '../sites';
import sitesTypes from '../sites/types';
import messages from './messages';
import types from './types';

export function* useAvailableCreditRequest() {
  let activateStates = [
    MOBILE_VIDEO_STATUS.INITIAL,
    MOBILE_VIDEO_STATUS.TRIAL_EXPIRED,
    MOBILE_VIDEO_STATUS.STANDARD_EXPIRED,
  ];
  try {
    const companyId = yield select(companySelectors.getCompanyId);
    const siteId = yield select(sitesSelectors.getSiteId);
    const licenceModel = yield select(sitesSelectors.getDashboardMvServiceLicenceModel);
    const action = { action: activateStates.includes(licenceModel.status) ? 'ACTIVATE' : 'CONSUME' };
    const response = yield call(Api.updateMvLicence, companyId, siteId, action);
    yield responseValidateStatusOrThrow(response);
    yield put({ type: sitesTypes.GET_CURRENT_SITE_LICENSE_MODEL_REQUEST });
    yield put({ type: sitesTypes.INVALIDATE_SITE_DASHBOARD });
  } catch (error) {
    yield put(errorHelper(types.GET_MOBILE_VIDEO_LICENSE_FAILURE, error));
  }
}

export function* paymentResultFromSocket({ data }) {
  if (data && data.purchasePaymentResult) {
    const result = {
      paymentResult: data.purchasePaymentResult.paymentResult,
      purchaseState: data.purchaseState,
    };
    yield put({ payload: result, type: types.SET_PAYMENT_RESULT });
  }
}

export function* activateActivationCode({ code }) {
  try {
    const companyId = yield select(companySelectors.getCompanyId);
    const siteId = yield select(sitesSelectors.getSiteId);
    const response = yield call(Api.activateActivationCode, companyId, siteId, code);
    yield responseValidateStatusOrThrow(response);
    yield put({ payload: response.data, type: types.ACTIVATE_ACTIVATION_CODE_SUCCESS });
  } catch (error) {
    yield put({ error, type: types.ACTIVATE_ACTIVATION_CODE_ERROR });
  }
}

export function* deactivateRecurringPayment() {
  try {
    const companyId = yield select(companySelectors.getCompanyId);
    const siteId = yield select(sitesSelectors.getSiteId);
    const action = { action: 'UNSUBSCRIBE' };
    const response = yield call(Api.updateMvLicence, companyId, siteId, action);
    yield responseValidateStatusOrThrow(response);
    yield put({ type: types.DEACTIVATE_RECURRING_PAYMENT_SUCCESS });
    yield put({ type: sitesTypes.DEACTIVATE_MV_RECURRING_PAYMENT });
    yield put(addSnackbarSuccess(messages.subscriptionSnackbarMVSubscriptionDeactivated));
  } catch (error) {
    yield put(errorHelper(types.DEACTIVATE_RECURRING_PAYMENT_FAILURE, error));
  }
}

export function* activateMobileVideo() {
  try {
    const companyId = yield select(companySelectors.getCompanyId);
    const siteId = yield select(sitesSelectors.getSiteId);
    const action = { action: 'ACTIVATE' };
    const response = yield call(Api.updateMvLicence, companyId, siteId, action);
    yield responseValidateStatusOrThrow(response);
    yield put({ type: sitesTypes.INVALIDATE_SITE });
    yield put({ type: types.ACTIVATE_MOBILE_VIDEO_LICENSE_SUCCESS });
  } catch (error) {
    yield put(errorHelper(types.ACTIVATE_MOBILE_VIDEO_LICENSE_FAILURE, error));
  }
}

export function* getVatVerification() {
  try {
    const companyId = yield select(companySelectors.getCompanyId);
    const response = yield call(Api.getVatVerification, companyId);
    if ([409].includes(response?.status)) {
      throw new Error();
    }
    yield put({ type: types.GET_VAT_VERIFICATION_SUCCES });
  } catch {
    yield put({ type: types.GET_VAT_VERIFICATION_ERROR });
  }
}

export default function* subscriptionSagas() {
  yield all([
    takeEvery(types.ACTIVATE_ACTIVATION_CODE_REQUEST, activateActivationCode),
    takeLatest(types.USE_AVAILABLE_CREDIT_REQUEST, useAvailableCreditRequest),
    takeLatest(types.PAYMENT_RESULT_FROM_SOCKET, paymentResultFromSocket),
    takeLatest(types.DEACTIVATE_RECURRING_PAYMENT_REQUEST, deactivateRecurringPayment),
    takeEvery(types.GET_VAT_VERIFICATION_REQUEST, getVatVerification),
    takeEvery(types.ACTIVATE_MOBILE_VIDEO_LICENSE_REQUEST, activateMobileVideo),
  ]);
}
